<template>
    <StreamsAndVisualizationsOverlay
        v-show="!!selectedStreamSection"
    >
        <StreamsAndVisualizationsContainer v-if="isEventOngoing" />
        <StreamEndedTimer v-if="shouldShowStreamEndedTimer" />
    </StreamsAndVisualizationsOverlay>
</template>

<script>
    import { mapGetters } from 'vuex';

    import StreamEndedTimer from '@modules/shared/StreamEndedTimer';
    import StreamsAndVisualizationsContainer from '@modules/sportOffer/sports/content/components/NewMatchDetailsStreamAndVisualizationsContainer';

    export default {
        data() {
            return { selectedStreamEventId: null };
        },
        computed: {
            ...mapGetters('ui/sportOffer', [
                'selectedStreamSection',
                'expandedEvent',
            ]),
            ...mapGetters('data/sportOffer', [
                'eventsMap',
            ]),
            selectedStreamEvent() {
                return this.eventsMap[this.selectedStreamEventId];
            },
            isEventOngoing() {
                return !!this.selectedStreamEvent?.isOngoing();
            },
            shouldShowStreamEndedTimer() {
                return !this.isEventOngoing && this.selectedStreamSection;
            },
        },
        watch: {
            selectedStreamSection(value) {
                if (value) {
                    this.selectedStreamEventId = this.expandedEvent;
                } else {
                    this.selectedStreamEventId = null;
                }
            },
        },
        components: {
            StreamsAndVisualizationsContainer,
            StreamEndedTimer,
            StreamsAndVisualizationsOverlay: () => import('stats/StreamsAndVisualizationsOverlay'),
        },
    };
</script>
